import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {TenantService} from './tenant.service';
import {Author} from '../models/author.model';
import {from, Observable} from 'rxjs';
import {readCollectionWithIds} from '../common/firestore-utils';
import {first} from 'rxjs/operators';


@Injectable({
  providedIn: "root"
})
export class AuthorsDbService {

  constructor(private afs: AngularFirestore,
              private tenant: TenantService) {

  }


  createNewAuthor(author: Partial<Author>): Observable<any> {

    const newAuthor = {...author};

    const id = newAuthor.id;
    delete newAuthor.id;

    return from(this.afs.doc(`schools/${this.tenant.id}/authors/${id}`).set(newAuthor, {merge:true}));
  }


  loadAllAuthors():Observable<Author[]> {
    return readCollectionWithIds<Author[]>(this.afs.collection(`schools/${this.tenant.id}/authors`)).pipe(first());

  }
}
